import { configureStore } from "@reduxjs/toolkit";
import artistasReducer from "explorer/reducers/artistas";
import genresSlice from "explorer/reducers/generos";
import usersReducer from "explorer/reducers/users";
import countriesReducer from "explorer/reducers/countries";
import authReducer from "explorer/reducers/auth";
import rankingsReducer from "explorer/reducers/rankings";
import monitoredData from "explorer/reducers/monitored-data";

export default configureStore({
  reducer: {
    users: usersReducer,
    artistas: artistasReducer,
    genres: genresSlice,
    countries: countriesReducer,
    auth: authReducer,
    rankings: rankingsReducer,
    monitoredData: monitoredData,
  },
});
